import { useEffect } from "react";
import { reportClientError } from "@/src/services/utils/clientErrorLogger";
import { captureError } from "@/src/lib/monitoring";

export default function ClientErrorListeners() {
  useEffect(() => {
    const handleWindowError = (event: ErrorEvent) => {
      reportClientError({
        type: "window.error",
        error: event.error,
        message: event.message,
        filename: event.filename,
        line: event.lineno,
        column: event.colno,
      });

      captureError(event.error, { source: "ui-error" });
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      reportClientError({
        type: "unhandledrejection",
        error: event.reason,
      });

      captureError(event.reason, { source: "ui-error" });
    };

    window.addEventListener("error", handleWindowError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleWindowError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, []);

  return null;
}
